import { apiCall } from "../api";

import ExternalFormDto from '../../DTOs/ExternalForm/ExternalFormDto.js';

export const getClientForm = async () => {
  let url = 'clientform/getForOrganization';
  let response = await apiCall(url);
  return new ExternalFormDto(response.result);
}
